import React from "react";
import { useTranslation, withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import InsButton from "../../InsButton/InsButton";
import images from "../../../ressources/images";

const AddToCartModal = () => {
  const { t } = useTranslation();

  return (
    <div className="modal_add_to_cart default-layout--min-height">
      <div className="content">{t("product_added")}</div>

      <div className="img_cart">
        <img src={images.cart_ok} alt="" />
      </div>

      <Link to="/shop">
        <InsButton type="outline" text={t("continue_shopping")} />
      </Link>

      <Link to="/shop/cart">
        <InsButton type="white" text={t("go_cart")} />
      </Link>
    </div>
  );
};

export default AddToCartModal;
